import React from "react";

// CSS
import "../../../css/errors-success/success.css";

class SuccessWrap extends React.PureComponent {
	render() {
		return <div className={`success-wrap` + (this.props.animate ? ` msg-animate` : ``)}>{this.props.children}</div>;
	}
}

export default SuccessWrap;



// WEBPACK FOOTER //
// ./src/components/utils/error-success/SuccessWrap.js